var Backbone = require('backbone');
var _ = require('underscore');

var Service = require('front/pages/Service/Service');
var SendButton = require('front/components/SendButton/SendButton');

require('./FeedbackPopup.less');

module.exports = Service.extend({
    template: require('./FeedbackPopup.jinja'),

    el: '.FeedbackPopup',

    events: {
        'click .SendButton': 'onSubmit',
        'input .FeedbackPopup-textarea, .FeedbackPopup-input': 'onChange',
        'change .FeedbackPopup-fileInput': 'onUpload'
    },

    initialize: function (options) {
        Service.prototype.initialize.call(this, options);

        if (this.options.server) {
            this.activateLogic();
        }
    },

    render: function () {
        Service.prototype.render.call(this);

        this.activateLogic();
    },

    viewsRegistration: function () {
        this.registerView('sendButton', new SendButton({
            el: this.$('.SendButton')
        }));
    },

    activateLogic: function () {
        Service.prototype.activateLogic.call(this);

        this.$textarea = this.$('.FeedbackPopup-textarea[name="description"]');
        this.$name = this.$('.FeedbackPopup-input[name="title"]');
        this.$img = this.$('.FeedbackPopup-fileInput[name="img"]');
        this.$btn = this.$('.SendButton');

        this.imageLoaded = false;

        this.onChange();
    },

    onSubmit: function (e) {
        var name = this.$name.val();
        var img = this.$img[0].files[0] || {};
        var description = this.$textarea.val();
        var formData = new FormData();
        formData.append('title', name);
        formData.append('img', img);
        formData.append('description', description);
        var sendButton = this.getView('sendButton');

        sendButton.submit(formData, '/api/feedback/');
    },

    onChange: function () {
        var img = this.$img[0].files[0] || '';

        this.$btn.prop('disabled', !this.$name.val() || !this.$textarea.val() || !img);
    },

    onUpload: function () {
        if (!this.imageLoaded) {
            this.$('.FeedbackPopup-fileLabel').text('Загрузить другую фотографию');
            this.imageLoaded = true;
        }

        this.onChange();
    },

    playIn: function () {
        this.$el.hide();

        return new Promise(function (resolve) {
            this.$el.fadeIn(function () {
                resolve();
            });
        }.bind(this));
    },

    playOut: function () {
        return new Promise(function (resolve) {
            this.$el.fadeOut(function () {
                resolve();
            });
        }.bind(this));
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Feedback/FeedbackPopup.js
// module id = 56
// module chunks = 0